import { render, staticRenderFns } from "./AdminOrder.vue?vue&type=template&id=7ac1eb92"
import script from "./AdminOrder.vue?vue&type=script&lang=ts"
export * from "./AdminOrder.vue?vue&type=script&lang=ts"
import style0 from "./AdminOrder.vue?vue&type=style&index=0&id=7ac1eb92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports